import {dot} from "mathjs";

export default class Map_Flight {
  viewer;
  datasource;
  params;
  measure;
  model3d;
  performance;
  id_cesiumContainer;

  constructor(viewer, model3d, performance, id_cesiumContainer) {
    this.viewer = viewer;
    this.model3d = model3d;
    this.id_cesiumContainer = id_cesiumContainer;
    this.performance = performance;
    this.datasource = undefined;
    this.params = {
      frustrum : {near : 0.01, far: 5000},
      stepline: 0.05,
      dist : {terrain : { near : 25, far : 50}, mesh : { near : 25, far : 50}},
      viewers : [],
      angles : [[0.9,0,0],[-0.9,0,0],[0,1,0],[0,-1,0]],
      isRenderTileset : false,
      needRenderTileset : false,
      sauvCamera: {position : undefined, heading : undefined, pitch : undefined, frustrum : {near : 0.01, far: 5000}},
      sauvModelQuality : 0,
      blockMeasure : {active : false, time : 1000},
    };
    this.measure = {
      coords : {start : undefined, end : undefined},
      needCalc : false,
      target : undefined,
      dists : [],
      recordsMesh : [] ,
      recordsTerrain : [] ,
      tline :0.0,
      sauvtline: undefined,
      idcam :0,
      sauvidcam : undefined,
      callBack : undefined,
      step : 0,

    };

    this.init();
  }

  init() {
    this.datasource = new Cesium.CustomDataSource("MapFlight");
    this.viewer.dataSources.add(this.datasource);
    this.viewer.scene.postRender.addEventListener(() => {
        this.postRender();
    });
    this.viewer.scene.preRender.addEventListener(() => {
      this.preRender();
  });
  }

  clear() {
    this.datasource.entities.removeAll();

  }

  cancel() {
    this.measure.needCalc = false;
    this.restoreCamera();
    this.showAll();
    this.restoreContainer();
    this.removeShader();
    this.restoreModelQuality();
    this.performance.setPause(false);
    this.endRecord(true);
  }

  SetHelperVisibility(isVisible) {

    this.datasource.entities.values.forEach((entity) => {
      if(entity.name && entity.name == "helper") {
        entity.show = isVisible;
      }
    });
  }

  setDepthVisibility(isVisible) {
      this.viewer.scene.globe.depthTestAgainstTerrain = isVisible;
  }

  setTilesetVisibility(isVisible) {
      this.viewer.scene.primitives.show = isVisible;
  }

  addPoint(depthIntersection,idcam) {

    //this.measure.target = new Cesium.Cartesian3(0,0,0);
		let color = undefined;
    if(idcam == 0) {
      color = Cesium.Color.ORANGE;
    }
    if(idcam == 1) {
      color = Cesium.Color.RED;
    }
    if(idcam == 2) {
      color = Cesium.Color.YELLOW;
    }
    if(idcam == 3) {
      color = Cesium.Color.GREEN;
    }
    this.datasource.entities.add({
      position: depthIntersection,
      point : {
        color: color,
        pixelSize: 8,
        outlineColor: Cesium.Color.WHITE,
        outlineWidth: 1
      },
    });

  }

  addControlPoint(FctGetPoint, Color) {
    let entity = this.datasource.entities.add({
      position: new Cesium.CallbackProperty(() => {
        return FctGetPoint();
      }, false),
      point : {
        color: Color,
        pixelSize: 6,
        outlineColor: Cesium.Color.WHITE,
        outlineWidth: 2
      },
    });
    return entity;
  }

  scanPolyLine(polyline, dists, callBackMessage, callBackFinish) {

    this.clear();
    this.snapshot();
    this.sauvCamera();
    this.hideAll();
    this.reduceContainer();
    this.addShader();
    this.setDistancesWarning(dists);
    this.forceModelQuality();
    this.performance.setPause(true);

    this.measure.callBackMessage = callBackMessage;
    this.measure.callBackFinish = callBackFinish;

    let listLinePosColor = [];
    this.measure.step =0;

    if(this.model3d.isVisible() == true) {
      this.params.needRenderTileset = true;
    }

    this.scanPolyLineNext(polyline,dists, listLinePosColor);
  }

  scanPolyLineNext(polyline,dists, listLinePosColor) {
    if(this.measure.step < polyline.length -1) {

      const coordStart = polyline[this.measure.step];
      const coordEnd = polyline[this.measure.step+1];
      const cartographicStart = new Cesium.Cartographic(coordStart[0], coordStart[1], coordStart[2] !== undefined ? coordStart[2] : 0);
      const cartographicEnd = new Cesium.Cartographic(coordEnd[0], coordEnd[1], coordEnd[2] !== undefined ? coordEnd[2] : 0);


      this.scanLine(cartographicStart, cartographicEnd,dists, (distMesh, distTerrain,linePosColor) => {

        if(this.measure.callBackMessage) {
          this.measure.callBackMessage( this.measure.step, distMesh, distTerrain);
        }
        listLinePosColor.push(linePosColor);
        this.measure.step +=1;
        this.scanPolyLineNext(polyline, dists, listLinePosColor);
      });
    }
    else{

      this.restoreCamera();
      this.showAll();
      this.restoreContainer();
      this.removeShader();
      this.restoreModelQuality();
      this.performance.setPause(false);

      if(this.measure.callBackFinish) {
        this.measure.callBackFinish(listLinePosColor);
      }
    }
  }

  scanLine(start, stop, dists, callBack) {

    this.measure.callBack = callBack;

    this.measure.coords.start = Cesium.Cartesian3.fromDegrees(start.longitude, start.latitude, start.height);
    this.measure.coords.end = Cesium.Cartesian3.fromDegrees(stop.longitude, stop.latitude, stop.height);
    const distanceLine = Cesium.Cartesian3.distance(this.measure.coords.start,  this.measure.coords.end);

    this.startRecord(distanceLine, dists);
  }

  startRecord(distanceLine, dists) {

    this.measure.recordsMesh = [];
    this.measure.recordsTerrain = [];
    this.measure.tline = 0.0;
    this.measure.sauvtline = undefined;
    this.measure.idcam =0;
    this.measure.sauvidcam = 0;
    this.measure.needCalc = true;

    if(this.params.needRenderTileset == true) {

      //3 mesures par distances near
      this.params.stepline =Math.min(Math.max((dists.mesh.near / 6) / distanceLine, 0.05), 0.25);
      // console.log("setp=" + this.params.stepline + "distanceLine" + distanceLine);

      this.params.isRenderTileset = true;
      this.setTilesetVisibility(true);
      this.setDepthVisibility(false);
    }
    else{

      //2 mesures par distances near
      this.params.stepline = Math.min(Math.max((dists.terrain.near / 4) / distanceLine, 0.05), 0.25);
      // console.log("setp=" + this.params.stepline + "distanceLine" + distanceLine);

      this.params.isRenderTileset = false;
      this.setDepthVisibility(true);
    }
  }

  endRecord(isCancel) {


    if(this.params.needRenderTileset == true) {
      this.setTilesetVisibility(true);
    }
    this.setDepthVisibility(true);

    this.measure.needCalc = false;

    if(this.measure.callBack != undefined && isCancel == false) {
      const linePosColor = this.discretiseLine();
      const dist = this.getrecordsResult();
      this.measure.callBack(dist.mesh, dist.terrain, linePosColor);
    }

  }

  preRender() {

    if(this.measure.needCalc == false) {
      return;
    }

    if(this.measure.sauvtline != this.measure.tline) {

      this.measure.sauvtline = this.measure.tline;

      if(this.measure.tline ==0 && this.params.isRenderTileset == true) {

          this.params.blockMeasure.active = true;
          setTimeout(() => {
            this.params.blockMeasure.active = false;
          }, this.params.blockMeasure.time);
      }

      if(this.measure.tline > 1) {
        if(this.params.isRenderTileset == false || this.params.needRenderTileset == false) {
          this.endRecord(false);
        }
        else{
          //deuxieme calcul : que le terain
          this.params.isRenderTileset = false;
          this.setTilesetVisibility(false);
					this.setDepthVisibility(true);
          this.measure.tline = 0.0;
        }
      }
      if(this.measure.tline + this.params.stepline > 1) {
        // console.log("refined last step");
        this.measure.tline = 0.99;
        this.measure.sauvtline = 0.99;
      }
    }
    else if(this.measure.sauvidcam != this.measure.idcam) {
      this.measure.sauvidcam = this.measure.idcam;

      if(this.measure.idcam == 4) {

        this.measure.idcam =0;
        this.measure.dists.sort((a, b) => {return a-b})
        const distMin = this.measure.dists[0];
        if(this.params.isRenderTileset == true && this.params.needRenderTileset == true) {
          this.measure.recordsMesh.push({"t":this.measure.tline, "dist" : distMin});
        }
        else{
          this.measure.recordsTerrain.push({"t":this.measure.tline, "dist" : distMin});
        }
        this.measure.tline += this.params.stepline;
      }
      else
      {
        //tline = 0.55;
        //tline = 0.9999;
        const coord = this.getlineAt(this.measure.tline);
        const coordb = this.getlineAt(this.measure.tline + 0.001);

        let direction = Cesium.Cartesian3.subtract(coordb, coord, new Cesium.Cartesian3());
        Cesium.Cartesian3.normalize(direction, direction);
        let approxUp = Cesium.Cartesian3.normalize(coord, new Cesium.Cartesian3());
        let right = Cesium.Cartesian3.cross(direction, approxUp, new Cesium.Cartesian3());
        right = Cesium.Cartesian3.normalize(right, right);
        let up = Cesium.Cartesian3.cross(right, direction, new Cesium.Cartesian3());
        up = Cesium.Cartesian3.normalize(up, up);

        this.viewer.camera.setView({
          destination : coord,
          orientation : {
            direction : direction,
            up : up
          }
        });
        const angle = this.params.angles[this.measure.idcam];
        this.viewer.camera.lookLeft(angle[0] * this.viewer.camera.frustum.fov);
        this.viewer.camera.lookUp((angle[1] * this.viewer.camera.frustum.fovy / 2) - Cesium.Math.toRadians(45));
        this.measure.target = coord;
      }

    }

  }

  postRender() {
    if(this.measure.needCalc == false) {
      return;
    }

    if(this.params.blockMeasure.active == true) {
      return;
    }

    this.measure.dists[this.measure.idcam] = this.CalcDist(this.viewer);
    this.measure.idcam +=1;
  }

  CalcDist(viewer) {

    let pixels = viewer.scene.context.readPixels();
    const width = viewer.scene.context.canvas.clientWidth;
    const height = viewer.scene.context.canvas.clientHeight;
    let dist =1000;

    let val_min = 255;
    let indice= -1;
    let nb_pixels = pixels.length /4;
    for(let i = 0; i< nb_pixels; i++) {
      const p = i * 4;
      const a = [pixels[p], pixels[p +1],pixels[p+2]];
      const len = a[0] + a[1] + a[2];

      //pixel noir
      if(len > 0) {
        const b = [1.0, 1.0 / 255.0, 1.0 / 65025.0];
        const val = dot(a, b);
        if(val < val_min) {
          val_min = val;
          indice = i;
        }
      }
    }
    if(indice >=0 ) {
      const windCoord = this.getPixelToWindow(indice, width, height);
      const depthIntersection = viewer.scene.pickPosition(windCoord);
      if( depthIntersection) {
        if($root.debug) {
          this.addPoint(depthIntersection,this.measure.idcam);
        }
        const cartdist = Cesium.Cartesian3.distance(depthIntersection, viewer.scene.camera.positionWC);
        if(cartdist != undefined && cartdist >0) {
          dist = cartdist;
        }
      }
    }

    return dist;
  }

  getPixelToWindow(p, width, height) {

    const intx = Math.floor(width);
    const inty = Math.floor(height);

    const y = Math.floor(p / intx);
    const x = p - (y * intx);

    return {'x': x , 'y': (height -y)};
  }

  getlineAt(t) {

    let coord ={};
    if(Cesium.defined(this.measure.coords.start) && Cesium.defined(this.measure.coords.end)) {
      Cesium.Cartesian3.lerp(this.measure.coords.start, this.measure.coords.end, t, coord);
    }
    return coord;
  }

  getrecordsResult() {

    let distMeshMin = Number.POSITIVE_INFINITY;
    let distTerrainMin = Number.POSITIVE_INFINITY;
    this.measure.recordsTerrain.forEach((record, id) => {

      const distMesh = this.params.needRenderTileset == true ? this.measure.recordsMesh[id].dist : Number.POSITIVE_INFINITY;
			const distTerrain = record.dist;

      if(distMesh < distMeshMin ) {
        distMeshMin = distMesh;
      }
      if(distTerrain < distTerrainMin ) {
        distTerrainMin = distTerrain;
      }

    });
    return {mesh:distMeshMin, terrain:distTerrainMin};
  }

  discretiseLine() {

    let coordinates = [];
    let colors = [];
    let color = Cesium.Color.GREEN;
    let isLastDetected = false;

    // console.log("discretiseLine");
    this.measure.recordsTerrain.forEach((record, id) => {
      let t = record.t;
      const distMesh = this.params.needRenderTileset == true ? this.measure.recordsMesh[id].dist : Number.POSITIVE_INFINITY;
			const distTerrain = record.dist;
      let dist = Math.min(distMesh,distTerrain);

      let coord ={};
      //let isLast= false;
      //if(id == this.measure.recordsMesh.length -1) {
      //  isLast = true;
      //}
      if(dist < this.params.dist.mesh.near) {
          color = Cesium.Color.RED;
          Cesium.Cartesian3.lerp(this.measure.coords.start, this.measure.coords.end, t, coord);
          //if(isLast) {
          //  isLastDetected = true;
         // }
      }
      else if( dist < this.params.dist.mesh.far) {
          color = Cesium.Color.ORANGE;
          Cesium.Cartesian3.lerp(this.measure.coords.start, this.measure.coords.end, t, coord);
          //if(isLast) {
          //  isLastDetected = true;
          //}
      }
      else{
          color = Cesium.Color.GREEN;
          Cesium.Cartesian3.lerp(this.measure.coords.start, this.measure.coords.end, t, coord);
         // if(isLast) {
          //  isLastDetected = true;
         // }
      }

      //if(isLast && isLastDetected == false) {
      //  Cesium.Cartesian3.lerp(this.measure.coords.start, this.measure.coords.end, t, coord);
      //  coordinates.push(coord);
      //  colors.push(color);
      //}
      //else if(coord.x && coord.y && coord.z){
        coordinates.push(coord);
        colors.push(color);
    //  }

    });

    return {"positions": coordinates, "colors" :colors};
  }


  snapshot() {

    this.viewer.render();
    let imgContainerImg = document.getElementById(this.id_cesiumContainer + "SnapshotImg");
    imgContainerImg.src = this.viewer.scene.canvas.toDataURL('image/png', 1.0);
    let imgContainer = document.getElementById(this.id_cesiumContainer + "Snapshot");
    imgContainer.style.display = "block";
  }

  hideAll() {
    //this.viewer.scene.primitives.show = false;
    this.viewer.dataSources._dataSources.forEach((dataSource) => {
      if(dataSource.name != "MapModels3d") {
        dataSource.show = false;
        dataSource._primitives.show = false;
      }
    });
  }

  showAll() {
    this.viewer.dataSources._dataSources.forEach((dataSource) => {
      if(dataSource.name != "MapModels3d") {
        dataSource.show = true;
        dataSource._primitives.show = true;
      }
    });
  }

  sauvCamera() {
    this.params.sauvCamera.position = this.viewer.camera.position.clone();
    this.params.sauvCamera.heading = this.viewer.camera.heading;
    this.params.sauvCamera.pitch = this.viewer.camera.pitch;
    this.params.sauvCamera.frustrum.near = this.viewer.camera.frustum.near;
    this.params.sauvCamera.frustrum.far = this.viewer.camera.frustum.far;

    this.viewer.camera.frustum.near = this.params.frustrum.near;
    this.viewer.camera.frustum.far = this.params.frustrum.far;
  }

  restoreCamera() {
    this.viewer.camera.setView({
      destination : this.params.sauvCamera.position,
      orientation: {
        heading : this.params.sauvCamera.heading,
        pitch : this.params.sauvCamera.pitch,
        roll : 0.0
      }
    });

    this.viewer.camera.frustum.near =this.params.sauvCamera.frustrum.near;
    this.viewer.camera.frustum.far = this.params.sauvCamera.frustrum.far;
  }

  forceModelQuality() {
    this.params.sauvModelQuality = this.model3d.getQuality();
    this.model3d.setQuality(undefined, 3);
  }

  restoreModelQuality() {
    this.model3d.setQuality(undefined, this.params.sauvModelQuality);
  }

  reduceContainer() {
    const ratio  = this.viewer.canvas.width / this.viewer.canvas.height;
    const width = 180;//240;
    const height = width / ratio;
    const cesiumContainer = document.getElementById(this.id_cesiumContainer);
    cesiumContainer.style.width = width + "px";
    cesiumContainer.style.height = height + "px";
  }

  restoreContainer() {
    const cesiumContainer = document.getElementById(this.id_cesiumContainer);
    cesiumContainer.style.width = "100%";
    cesiumContainer.style.height = "100%";

    let imgContainer = document.getElementById(this.id_cesiumContainer + "Snapshot");
    imgContainer.style.display = "none";

  }

  addShader() {
    const fragmentShaderSource = `
    uniform sampler2D depthTexture;
    in vec2 v_textureCoordinates;
    void main(void)
    {
      out_FragColor = czm_packDepth(texture(depthTexture, v_textureCoordinates).r);
    }
  `;

    this.viewer.scene.postProcessStages.add(
      new Cesium.PostProcessStage({
        fragmentShader: fragmentShaderSource
      })
    );
  }

  removeShader() {
    this.viewer.scene.postProcessStages.removeAll();
  }

  setDistancesWarning(dists) {
    if(dists?.terrain?.far) {
      this.params.dist.terrain.far = dists.terrain.far;
    }
    if(dists?.terrain?.near) {
      this.params.dist.terrain.near = dists.terrain.near;
    }
    if(this.params.dist.terrain.far <this.params.dist.terrain.near) {
      this.params.dist.terrain.far = this.params.dist.terrain.near;
    }

    if(dists?.mesh?.far) {
      this.params.dist.mesh.far = dists.mesh.far;
    }
    if(dists?.mesh?.near) {
      this.params.dist.mesh.near = dists.mesh.near;
    }
    if(this.params.dist.mesh.far <this.params.dist.mesh.near) {
      this.params.dist.mesh.far = this.params.dist.mesh.near;
    }
  }

}
